import { type AutosDealerAmountPrice, type ListingPrice } from '@kijiji/generated/graphql-types'
import { formatPrice } from '@kijiji/money'
import { type TFunction } from 'next-i18next'

import { isAutosDealerAmountPrice } from '@/domain/listings/AutosDealerAmountPrice'
import { type RouteLocale, ROUTE_LOCALE } from '@/domain/locale'

/**
 * What the retail price would be from a dealership.
 * When a car is posted, the seller has to enter the price that would cost to buy retail.
 */
export const getMSRPValue = ({
  msrp,
  routeLocale,
  t,
  price,
}: {
  price?: ListingPrice
  msrp?: AutosDealerAmountPrice['msrp']
  routeLocale: RouteLocale
  t: TFunction
}): string | null => {
  if ((!!price && !isAutosDealerAmountPrice(price)) || (!price && !msrp)) return null

  const msrpValue = msrp ?? price?.msrp ?? null

  /**
   * The MSRP value should only be displayed if:
   * - There is aMSRP value AND
   * - If it is a new car
   *
   * In all other cases it shouldn't be displayed
   */
  if (!msrpValue) return null

  const formattedMSRP = formatPrice(msrpValue, {
    isFrench: routeLocale === ROUTE_LOCALE.fr,
    suppressCents: true,
  })
  return t('listing:price.msrp', { price: formattedMSRP })
}
